const dot = "h-2 w-2 bg-white/25 max600:h-1.5 max600:w-1.5";

const WindowDots = () => (
  <div className="flex items-center gap-1.5">
    <span className={dot}></span>
    <span className={dot}></span>
    <span className={dot}></span>
  </div>
);

export default WindowDots;
